import "./StoreTerminalSelector.scss"

import React from "react"

// Reusable store/terminal picker, extracted from KitchenStationForm. A
// whole-store checkbox covers every (current and future) terminal of the store;
// otherwise individual terminals can be picked. Selecting the whole store drops
// any individually-selected terminals of that store, since they'd be redundant.
//
// Controlled via two id arrays and two change callbacks so it stays decoupled
// from any particular form/state helper.
const StoreTerminalSelector = ({
  stores = [],
  storeIds = [],
  terminalIds = [],
  onStoreIdsChange,
  onTerminalIdsChange,
  emptyText = "No stores or terminals defined yet.",
}) => {
  const selectedStoreIds = new Set(storeIds)
  const selectedTerminalIds = new Set(terminalIds)

  const toggleStore = (store) => {
    if (selectedStoreIds.has(store.id)) {
      onStoreIdsChange(storeIds.filter((id) => id !== store.id))
      return
    }
    const terminalsInStore = new Set((store.terminals || []).map((t) => t.id))
    onTerminalIdsChange(terminalIds.filter((id) => !terminalsInStore.has(id)))
    onStoreIdsChange([...storeIds, store.id])
  }

  const toggleTerminal = (terminalId) => {
    onTerminalIdsChange(
      terminalIds.includes(terminalId)
        ? terminalIds.filter((id) => id !== terminalId)
        : [...terminalIds, terminalId]
    )
  }

  if (stores.length === 0) {
    return <p className="has-text-grey is-italic">{emptyText}</p>
  }

  return (
    <div className="StoreTerminalSelector">
      <div className="store-list">
        {stores.map((store) => {
          const storeChecked = selectedStoreIds.has(store.id)
          return (
            <div key={store.id} className="store-group">
              <label className={`store-row ${storeChecked ? "checked" : ""}`}>
                <input
                  type="checkbox"
                  checked={storeChecked}
                  onChange={() => toggleStore(store)}
                />
                <span className="store-name">{store.name}</span>
                <span className="store-hint">whole store</span>
              </label>
              {(store.terminals || []).length === 0 ? (
                <p className="terminal-empty has-text-grey is-italic">
                  No terminals in this store yet.
                </p>
              ) : (
                <div className="terminal-list">
                  {store.terminals.map((terminal) => {
                    const checked = storeChecked || selectedTerminalIds.has(terminal.id)
                    return (
                      <label
                        key={terminal.id}
                        className={`terminal-chip ${checked ? "checked" : ""} ${storeChecked ? "covered" : ""}`}
                      >
                        <input
                          type="checkbox"
                          checked={checked}
                          disabled={storeChecked}
                          onChange={() => toggleTerminal(terminal.id)}
                        />
                        {terminal.name}
                      </label>
                    )
                  })}
                </div>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default StoreTerminalSelector
